module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/feature02-92fdb573e0ab5c5be5579904af07fc86.svg";